/**
 * TakeNote's mark beside its name, at the top of every web page (Phase 12.5).
 *
 * The mark and the word together, not the mark alone: the word is what tells
 * someone arriving from an email link where they are. One component rather
 * than one page shell - the pages draw their own cards at different widths,
 * and each only needs this line above its heading. `test:nav` checks every
 * page renders it.
 *
 * A band across the top of the card since Phase 14.5 (the Lagoon, deeper
 * look), in the mark's own teal (.brand-band, index.css), as the popup's
 * header is. Every page draws it first in a card padded p-6, so it cancels
 * that 1.5rem on three sides to reach the card's edges and takes the card's
 * rounded top corners. The margins are inline because some cards space their
 * children with space-y-4, whose margin rules would otherwise compete with a
 * margin class; the bottom margin is left to `className` or to space-y.
 *
 * `/mark.svg` is generated from brand/mark.svg by `pnpm icons`.
 */
export default function BrandHeader({ className = "mb-4" }: { className?: string }) {
  return (
    <div
      className={`brand-band flex items-center gap-2 rounded-t-[inherit] px-6 py-3 text-lg font-semibold ${className}`}
      style={{ marginTop: "-1.5rem", marginLeft: "-1.5rem", marginRight: "-1.5rem" }}
    >
      <img src="/mark.svg" alt="" width={28} height={28} className="block" />
      <span>TakeNote</span>
    </div>
  );
}
